/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from "./routes/__root"
import { Route as LabRouteImport } from "./routes/lab/route"
import { Route as AuthRouteImport } from "./routes/auth/route"
import { Route as IndexImport } from "./routes/index"
import { Route as LabMutationThrottleImport } from "./routes/lab/mutation-throttle"
import { Route as LabModalImport } from "./routes/lab/modal"
import { Route as LabErrorImport } from "./routes/lab/error"
import { Route as LabButtonsImport } from "./routes/lab/buttons"
import { Route as AuthSignupImport } from "./routes/auth/signup"
import { Route as AuthResetPasswordImport } from "./routes/auth/reset-password"
import { Route as AuthLoginImport } from "./routes/auth/login"
import { Route as ArtworkCreateImport } from "./routes/artwork/create"
import { Route as ArtworkArtworkIdImport } from "./routes/artwork/$artworkId"
import { Route as UserSettingsRouteImport } from "./routes/user/settings/route"
import { Route as UserUsernameRouteImport } from "./routes/user/$username/route"
import { Route as UserSettingsIndexImport } from "./routes/user/settings/index"
import { Route as UserSettingsProfileImport } from "./routes/user/settings/profile"
import { Route as UserUsernameGalleryImport } from "./routes/user/$username/gallery"
import { Route as UserUsernameFollowingImport } from "./routes/user/$username/following"
import { Route as UserUsernameFollowersImport } from "./routes/user/$username/followers"
import { Route as ArtworkArtworkIdModalImport } from "./routes/artwork/$artworkId.modal"

// Create/Update Routes

const LabRouteRoute = LabRouteImport.update({
  id: "/lab",
  path: "/lab",
  getParentRoute: () => rootRoute,
} as any)

const AuthRouteRoute = AuthRouteImport.update({
  id: "/auth",
  path: "/auth",
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRoute,
} as any)

const LabMutationThrottleRoute = LabMutationThrottleImport.update({
  id: "/mutation-throttle",
  path: "/mutation-throttle",
  getParentRoute: () => LabRouteRoute,
} as any)

const LabModalRoute = LabModalImport.update({
  id: "/modal",
  path: "/modal",
  getParentRoute: () => LabRouteRoute,
} as any)

const LabErrorRoute = LabErrorImport.update({
  id: "/error",
  path: "/error",
  getParentRoute: () => LabRouteRoute,
} as any)

const LabButtonsRoute = LabButtonsImport.update({
  id: "/buttons",
  path: "/buttons",
  getParentRoute: () => LabRouteRoute,
} as any)

const AuthSignupRoute = AuthSignupImport.update({
  id: "/signup",
  path: "/signup",
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthResetPasswordRoute = AuthResetPasswordImport.update({
  id: "/reset-password",
  path: "/reset-password",
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthLoginRoute = AuthLoginImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => AuthRouteRoute,
} as any)

const ArtworkCreateRoute = ArtworkCreateImport.update({
  id: "/artwork/create",
  path: "/artwork/create",
  getParentRoute: () => rootRoute,
} as any)

const ArtworkArtworkIdRoute = ArtworkArtworkIdImport.update({
  id: "/artwork/$artworkId",
  path: "/artwork/$artworkId",
  getParentRoute: () => rootRoute,
} as any)

const UserSettingsRouteRoute = UserSettingsRouteImport.update({
  id: "/user/settings",
  path: "/user/settings",
  getParentRoute: () => rootRoute,
} as any)

const UserUsernameRouteRoute = UserUsernameRouteImport.update({
  id: "/user/$username",
  path: "/user/$username",
  getParentRoute: () => rootRoute,
} as any)

const UserSettingsIndexRoute = UserSettingsIndexImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => UserSettingsRouteRoute,
} as any)

const UserSettingsProfileRoute = UserSettingsProfileImport.update({
  id: "/profile",
  path: "/profile",
  getParentRoute: () => UserSettingsRouteRoute,
} as any)

const UserUsernameGalleryRoute = UserUsernameGalleryImport.update({
  id: "/gallery",
  path: "/gallery",
  getParentRoute: () => UserUsernameRouteRoute,
} as any)

const UserUsernameFollowingRoute = UserUsernameFollowingImport.update({
  id: "/following",
  path: "/following",
  getParentRoute: () => UserUsernameRouteRoute,
} as any)

const UserUsernameFollowersRoute = UserUsernameFollowersImport.update({
  id: "/followers",
  path: "/followers",
  getParentRoute: () => UserUsernameRouteRoute,
} as any)

const ArtworkArtworkIdModalRoute = ArtworkArtworkIdModalImport.update({
  id: "/modal",
  path: "/modal",
  getParentRoute: () => ArtworkArtworkIdRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    "/auth": {
      id: "/auth"
      path: "/auth"
      fullPath: "/auth"
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRoute
    }
    "/lab": {
      id: "/lab"
      path: "/lab"
      fullPath: "/lab"
      preLoaderRoute: typeof LabRouteImport
      parentRoute: typeof rootRoute
    }
    "/user/$username": {
      id: "/user/$username"
      path: "/user/$username"
      fullPath: "/user/$username"
      preLoaderRoute: typeof UserUsernameRouteImport
      parentRoute: typeof rootRoute
    }
    "/user/settings": {
      id: "/user/settings"
      path: "/user/settings"
      fullPath: "/user/settings"
      preLoaderRoute: typeof UserSettingsRouteImport
      parentRoute: typeof rootRoute
    }
    "/artwork/$artworkId": {
      id: "/artwork/$artworkId"
      path: "/artwork/$artworkId"
      fullPath: "/artwork/$artworkId"
      preLoaderRoute: typeof ArtworkArtworkIdImport
      parentRoute: typeof rootRoute
    }
    "/artwork/create": {
      id: "/artwork/create"
      path: "/artwork/create"
      fullPath: "/artwork/create"
      preLoaderRoute: typeof ArtworkCreateImport
      parentRoute: typeof rootRoute
    }
    "/auth/login": {
      id: "/auth/login"
      path: "/login"
      fullPath: "/auth/login"
      preLoaderRoute: typeof AuthLoginImport
      parentRoute: typeof AuthRouteImport
    }
    "/auth/reset-password": {
      id: "/auth/reset-password"
      path: "/reset-password"
      fullPath: "/auth/reset-password"
      preLoaderRoute: typeof AuthResetPasswordImport
      parentRoute: typeof AuthRouteImport
    }
    "/auth/signup": {
      id: "/auth/signup"
      path: "/signup"
      fullPath: "/auth/signup"
      preLoaderRoute: typeof AuthSignupImport
      parentRoute: typeof AuthRouteImport
    }
    "/lab/buttons": {
      id: "/lab/buttons"
      path: "/buttons"
      fullPath: "/lab/buttons"
      preLoaderRoute: typeof LabButtonsImport
      parentRoute: typeof LabRouteImport
    }
    "/lab/error": {
      id: "/lab/error"
      path: "/error"
      fullPath: "/lab/error"
      preLoaderRoute: typeof LabErrorImport
      parentRoute: typeof LabRouteImport
    }
    "/lab/modal": {
      id: "/lab/modal"
      path: "/modal"
      fullPath: "/lab/modal"
      preLoaderRoute: typeof LabModalImport
      parentRoute: typeof LabRouteImport
    }
    "/lab/mutation-throttle": {
      id: "/lab/mutation-throttle"
      path: "/mutation-throttle"
      fullPath: "/lab/mutation-throttle"
      preLoaderRoute: typeof LabMutationThrottleImport
      parentRoute: typeof LabRouteImport
    }
    "/artwork/$artworkId/modal": {
      id: "/artwork/$artworkId/modal"
      path: "/modal"
      fullPath: "/artwork/$artworkId/modal"
      preLoaderRoute: typeof ArtworkArtworkIdModalImport
      parentRoute: typeof ArtworkArtworkIdImport
    }
    "/user/$username/followers": {
      id: "/user/$username/followers"
      path: "/followers"
      fullPath: "/user/$username/followers"
      preLoaderRoute: typeof UserUsernameFollowersImport
      parentRoute: typeof UserUsernameRouteImport
    }
    "/user/$username/following": {
      id: "/user/$username/following"
      path: "/following"
      fullPath: "/user/$username/following"
      preLoaderRoute: typeof UserUsernameFollowingImport
      parentRoute: typeof UserUsernameRouteImport
    }
    "/user/$username/gallery": {
      id: "/user/$username/gallery"
      path: "/gallery"
      fullPath: "/user/$username/gallery"
      preLoaderRoute: typeof UserUsernameGalleryImport
      parentRoute: typeof UserUsernameRouteImport
    }
    "/user/settings/profile": {
      id: "/user/settings/profile"
      path: "/profile"
      fullPath: "/user/settings/profile"
      preLoaderRoute: typeof UserSettingsProfileImport
      parentRoute: typeof UserSettingsRouteImport
    }
    "/user/settings/": {
      id: "/user/settings/"
      path: "/"
      fullPath: "/user/settings/"
      preLoaderRoute: typeof UserSettingsIndexImport
      parentRoute: typeof UserSettingsRouteImport
    }
  }
}

// Create and export the route tree

interface AuthRouteRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignupRoute: typeof AuthSignupRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignupRoute: AuthSignupRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface LabRouteRouteChildren {
  LabButtonsRoute: typeof LabButtonsRoute
  LabErrorRoute: typeof LabErrorRoute
  LabModalRoute: typeof LabModalRoute
  LabMutationThrottleRoute: typeof LabMutationThrottleRoute
}

const LabRouteRouteChildren: LabRouteRouteChildren = {
  LabButtonsRoute: LabButtonsRoute,
  LabErrorRoute: LabErrorRoute,
  LabModalRoute: LabModalRoute,
  LabMutationThrottleRoute: LabMutationThrottleRoute,
}

const LabRouteRouteWithChildren = LabRouteRoute._addFileChildren(
  LabRouteRouteChildren,
)

interface UserUsernameRouteRouteChildren {
  UserUsernameFollowersRoute: typeof UserUsernameFollowersRoute
  UserUsernameFollowingRoute: typeof UserUsernameFollowingRoute
  UserUsernameGalleryRoute: typeof UserUsernameGalleryRoute
}

const UserUsernameRouteRouteChildren: UserUsernameRouteRouteChildren = {
  UserUsernameFollowersRoute: UserUsernameFollowersRoute,
  UserUsernameFollowingRoute: UserUsernameFollowingRoute,
  UserUsernameGalleryRoute: UserUsernameGalleryRoute,
}

const UserUsernameRouteRouteWithChildren =
  UserUsernameRouteRoute._addFileChildren(UserUsernameRouteRouteChildren)

interface UserSettingsRouteRouteChildren {
  UserSettingsProfileRoute: typeof UserSettingsProfileRoute
  UserSettingsIndexRoute: typeof UserSettingsIndexRoute
}

const UserSettingsRouteRouteChildren: UserSettingsRouteRouteChildren = {
  UserSettingsProfileRoute: UserSettingsProfileRoute,
  UserSettingsIndexRoute: UserSettingsIndexRoute,
}

const UserSettingsRouteRouteWithChildren =
  UserSettingsRouteRoute._addFileChildren(UserSettingsRouteRouteChildren)

interface ArtworkArtworkIdRouteChildren {
  ArtworkArtworkIdModalRoute: typeof ArtworkArtworkIdModalRoute
}

const ArtworkArtworkIdRouteChildren: ArtworkArtworkIdRouteChildren = {
  ArtworkArtworkIdModalRoute: ArtworkArtworkIdModalRoute,
}

const ArtworkArtworkIdRouteWithChildren =
  ArtworkArtworkIdRoute._addFileChildren(ArtworkArtworkIdRouteChildren)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/auth": typeof AuthRouteRouteWithChildren
  "/lab": typeof LabRouteRouteWithChildren
  "/user/$username": typeof UserUsernameRouteRouteWithChildren
  "/user/settings": typeof UserSettingsRouteRouteWithChildren
  "/artwork/$artworkId": typeof ArtworkArtworkIdRouteWithChildren
  "/artwork/create": typeof ArtworkCreateRoute
  "/auth/login": typeof AuthLoginRoute
  "/auth/reset-password": typeof AuthResetPasswordRoute
  "/auth/signup": typeof AuthSignupRoute
  "/lab/buttons": typeof LabButtonsRoute
  "/lab/error": typeof LabErrorRoute
  "/lab/modal": typeof LabModalRoute
  "/lab/mutation-throttle": typeof LabMutationThrottleRoute
  "/artwork/$artworkId/modal": typeof ArtworkArtworkIdModalRoute
  "/user/$username/followers": typeof UserUsernameFollowersRoute
  "/user/$username/following": typeof UserUsernameFollowingRoute
  "/user/$username/gallery": typeof UserUsernameGalleryRoute
  "/user/settings/profile": typeof UserSettingsProfileRoute
  "/user/settings/": typeof UserSettingsIndexRoute
}

export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/auth": typeof AuthRouteRouteWithChildren
  "/lab": typeof LabRouteRouteWithChildren
  "/user/$username": typeof UserUsernameRouteRouteWithChildren
  "/artwork/$artworkId": typeof ArtworkArtworkIdRouteWithChildren
  "/artwork/create": typeof ArtworkCreateRoute
  "/auth/login": typeof AuthLoginRoute
  "/auth/reset-password": typeof AuthResetPasswordRoute
  "/auth/signup": typeof AuthSignupRoute
  "/lab/buttons": typeof LabButtonsRoute
  "/lab/error": typeof LabErrorRoute
  "/lab/modal": typeof LabModalRoute
  "/lab/mutation-throttle": typeof LabMutationThrottleRoute
  "/artwork/$artworkId/modal": typeof ArtworkArtworkIdModalRoute
  "/user/$username/followers": typeof UserUsernameFollowersRoute
  "/user/$username/following": typeof UserUsernameFollowingRoute
  "/user/$username/gallery": typeof UserUsernameGalleryRoute
  "/user/settings/profile": typeof UserSettingsProfileRoute
  "/user/settings": typeof UserSettingsIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  "/": typeof IndexRoute
  "/auth": typeof AuthRouteRouteWithChildren
  "/lab": typeof LabRouteRouteWithChildren
  "/user/$username": typeof UserUsernameRouteRouteWithChildren
  "/user/settings": typeof UserSettingsRouteRouteWithChildren
  "/artwork/$artworkId": typeof ArtworkArtworkIdRouteWithChildren
  "/artwork/create": typeof ArtworkCreateRoute
  "/auth/login": typeof AuthLoginRoute
  "/auth/reset-password": typeof AuthResetPasswordRoute
  "/auth/signup": typeof AuthSignupRoute
  "/lab/buttons": typeof LabButtonsRoute
  "/lab/error": typeof LabErrorRoute
  "/lab/modal": typeof LabModalRoute
  "/lab/mutation-throttle": typeof LabMutationThrottleRoute
  "/artwork/$artworkId/modal": typeof ArtworkArtworkIdModalRoute
  "/user/$username/followers": typeof UserUsernameFollowersRoute
  "/user/$username/following": typeof UserUsernameFollowingRoute
  "/user/$username/gallery": typeof UserUsernameGalleryRoute
  "/user/settings/profile": typeof UserSettingsProfileRoute
  "/user/settings/": typeof UserSettingsIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/auth"
    | "/lab"
    | "/user/$username"
    | "/user/settings"
    | "/artwork/$artworkId"
    | "/artwork/create"
    | "/auth/login"
    | "/auth/reset-password"
    | "/auth/signup"
    | "/lab/buttons"
    | "/lab/error"
    | "/lab/modal"
    | "/lab/mutation-throttle"
    | "/artwork/$artworkId/modal"
    | "/user/$username/followers"
    | "/user/$username/following"
    | "/user/$username/gallery"
    | "/user/settings/profile"
    | "/user/settings/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/auth"
    | "/lab"
    | "/user/$username"
    | "/artwork/$artworkId"
    | "/artwork/create"
    | "/auth/login"
    | "/auth/reset-password"
    | "/auth/signup"
    | "/lab/buttons"
    | "/lab/error"
    | "/lab/modal"
    | "/lab/mutation-throttle"
    | "/artwork/$artworkId/modal"
    | "/user/$username/followers"
    | "/user/$username/following"
    | "/user/$username/gallery"
    | "/user/settings/profile"
    | "/user/settings"
  id:
    | "__root__"
    | "/"
    | "/auth"
    | "/lab"
    | "/user/$username"
    | "/user/settings"
    | "/artwork/$artworkId"
    | "/artwork/create"
    | "/auth/login"
    | "/auth/reset-password"
    | "/auth/signup"
    | "/lab/buttons"
    | "/lab/error"
    | "/lab/modal"
    | "/lab/mutation-throttle"
    | "/artwork/$artworkId/modal"
    | "/user/$username/followers"
    | "/user/$username/following"
    | "/user/$username/gallery"
    | "/user/settings/profile"
    | "/user/settings/"
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  LabRouteRoute: typeof LabRouteRouteWithChildren
  UserUsernameRouteRoute: typeof UserUsernameRouteRouteWithChildren
  UserSettingsRouteRoute: typeof UserSettingsRouteRouteWithChildren
  ArtworkArtworkIdRoute: typeof ArtworkArtworkIdRouteWithChildren
  ArtworkCreateRoute: typeof ArtworkCreateRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  LabRouteRoute: LabRouteRouteWithChildren,
  UserUsernameRouteRoute: UserUsernameRouteRouteWithChildren,
  UserSettingsRouteRoute: UserSettingsRouteRouteWithChildren,
  ArtworkArtworkIdRoute: ArtworkArtworkIdRouteWithChildren,
  ArtworkCreateRoute: ArtworkCreateRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/auth",
        "/lab",
        "/user/$username",
        "/user/settings",
        "/artwork/$artworkId",
        "/artwork/create"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/auth": {
      "filePath": "auth/route.tsx",
      "children": [
        "/auth/login",
        "/auth/reset-password",
        "/auth/signup"
      ]
    },
    "/lab": {
      "filePath": "lab/route.tsx",
      "children": [
        "/lab/buttons",
        "/lab/error",
        "/lab/modal",
        "/lab/mutation-throttle"
      ]
    },
    "/user/$username": {
      "filePath": "user/$username/route.tsx",
      "children": [
        "/user/$username/followers",
        "/user/$username/following",
        "/user/$username/gallery"
      ]
    },
    "/user/settings": {
      "filePath": "user/settings/route.tsx",
      "children": [
        "/user/settings/profile",
        "/user/settings/"
      ]
    },
    "/artwork/$artworkId": {
      "filePath": "artwork/$artworkId.tsx",
      "children": [
        "/artwork/$artworkId/modal"
      ]
    },
    "/artwork/create": {
      "filePath": "artwork/create.tsx"
    },
    "/auth/login": {
      "filePath": "auth/login.tsx",
      "parent": "/auth"
    },
    "/auth/reset-password": {
      "filePath": "auth/reset-password.tsx",
      "parent": "/auth"
    },
    "/auth/signup": {
      "filePath": "auth/signup.tsx",
      "parent": "/auth"
    },
    "/lab/buttons": {
      "filePath": "lab/buttons.tsx",
      "parent": "/lab"
    },
    "/lab/error": {
      "filePath": "lab/error.tsx",
      "parent": "/lab"
    },
    "/lab/modal": {
      "filePath": "lab/modal.tsx",
      "parent": "/lab"
    },
    "/lab/mutation-throttle": {
      "filePath": "lab/mutation-throttle.tsx",
      "parent": "/lab"
    },
    "/artwork/$artworkId/modal": {
      "filePath": "artwork/$artworkId.modal.tsx",
      "parent": "/artwork/$artworkId"
    },
    "/user/$username/followers": {
      "filePath": "user/$username/followers.tsx",
      "parent": "/user/$username"
    },
    "/user/$username/following": {
      "filePath": "user/$username/following.tsx",
      "parent": "/user/$username"
    },
    "/user/$username/gallery": {
      "filePath": "user/$username/gallery.tsx",
      "parent": "/user/$username"
    },
    "/user/settings/profile": {
      "filePath": "user/settings/profile.tsx",
      "parent": "/user/settings"
    },
    "/user/settings/": {
      "filePath": "user/settings/index.tsx",
      "parent": "/user/settings"
    }
  }
}
ROUTE_MANIFEST_END */
